import React, { useState, useRef, useImperativeHandle } from "react";
import {  Tooltip, theme } from "antd";
import {  EditOutlined , PlusCircleFilled } from "@ant-design/icons";
import TSTable from "../../../common/TSTable";
import ColorButton from "../../../common/ColorButton";
import { DELETE } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import AddPondModal from "./AddPondModal";
import ErrorMessages from "../../../common/ErrorMessages";
import { dateToHumanString, formatComma } from "../../../frameworks/Util";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

const PondList = React.forwardRef((props, ref) => {
  const [openAddPondModal, setOpenAddPondModal] = useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages] = useState(null);
  
  const { token: { colorSuccess, colorWarning }, } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) { 
        setErrorMessages(error.errorMessages);
      }
    }
  };
  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
    setOpenAddPondModal(true);
  };

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_SETTING.POND}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
              <CustomDeleteConfirmButton
                title={`ยืนยันลบหรือไม่`}
                content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
                onOk={ async() => {
                  await handleDelete(record.id)
                  refreshData();
                }}
                onConfirm={() => refreshData()}
                disabled={record.current_transaction ? true : false}
                tooltips={record.current_transaction ? 'ไม่สามารถลบบ่อที่มีล็อตได้' : 'ลบข้อมูล'}
              />
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                style={{ margin: 5 }}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "ชื่อบ่อพัก",
      dataIndex: "name",
      key: "name",
      searcher : true,
      align: "center",
    },
    {
      title: "น้ำหนัก (Kg) / ความสูง 1 cm",
      dataIndex: "weight_per_height",
      key: "weight_per_height",
      align: "center",
      render: (value) => value ? formatComma(value) : ' - '
    },
    {
      title: "ลำดับการแสดง",
      dataIndex: "display_seq",
      key: "display_seq",
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
      type="primary"
      override={colorSuccess}
      icon={<PlusCircleFilled />}
      style={{ marginBottom : 10 , float: "right" }}
      onClick={() => setOpenAddPondModal (true)}
      > 
      เพิ่มบ่อพักน้ำยาง
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={URL_SETTING.POND}
        ref={tableRef}
      />
      <AddPondModal
        open={openAddPondModal}
        onClose={() => {
          setOpenAddPondModal(false);
          setTarget(null);
        }}
        onUpdate={() => {
          setOpenAddPondModal(false);
          setTarget(null);
          refreshData();
        }}
        target={target}
      />
    </div>
  );
});

export default PondList;
